import axios from "axios";
import * as vueMethods from "../../../../libraries/VueMethods";
import cart from "@/parts/Front/components/cart/cart";
import notification from "@/parts/Front/components/notification/classes/notification";
const state = {
  homeData: null,
  homeDataStatus: false,

  // آرایه از توابع که بعد از لود شدن هوم اجرا میشن
  onHomeDataRetrieved: [],
  giftPackages: null,
  packagePrice: 0,
  sliders: null,
  packageId: null,
  oldRequestedProduct: [],
  falties: [],
};
const getters = {
  getFalties(state) {
    return state.falties;
  },
  getVipProducts: () => {
    return state.vip_unpublished_products;
  },
  
  getNewProducts: () => {
    return state.new_products;
  },
  getDiscountProducts: () => {
    return state.discount_products;
  },
  getMostSales: () => {
    return state.mostSales;
  },
  getMostDiscounts: () => {
    return state.mostDiscount;
  },
  getSuggestions: () => {
    return state.suggestions;
  },

  getSliders: () => {
    return state.sliders;
  },
  getPackageId() {
    return state.packageId;
  },
  getPackagePrice(state) {
    return state.packagePrice;
  },
  getGiftPackages(state) {
    return state.giftPackages;
  },
  getHomeData(state) {
    //دریافت اطلاعات برای صفحه اصلی
    return state.homeData;
  },
  isAuthenticated(state) {
    //آیا لاگین کرده
    return state.homeData;
  },
  getProductSuggestions(state) {
    return state.productSuggestions;
  },

  getHomeDataStatus(state) {
    return state.homeDataStatus;
  },

  // گرفتن سایز های موجود
  // getSizeValues(state) {
  //     return state.homeData ? state.homeData.size_values : null
  // },
  // getColors(state) {
  //     return state.homeData ? state.homeData.colors : null
  // },
};
const mutations = {
  setFalties(state, list) {
    state.falties = list;
  },
  changeOldRequestList(state, newValue) {
    let lastValue = state.oldRequestedProduct;
    lastValue.push(newValue);
    state.oldRequestedProduct = lastValue;
  },
  setProductList(state, dataList) {
    state[dataList.key] = dataList.list;
  },
  setSliders(state, list) {
    state.sliders = list;
  },
  setPackageID(state, id) {
    state.packageId = id;
  },
  setPackagePrice(state, newPrice) {
    state.packagePrice = newPrice;
  },
  setGiftPackages(state, packagesList) {
    state.giftPackages = packagesList;
  },
  setHomeDataStatus(state, status) {
    //ست کردن استاسوس اطلاعات صفحه اصلی
    state.homeDataStatus = status;
  },
  setHomeData(state, data) {
    //ست کردن اطلاعات صفحه اصلی
    if (data.colors) {
      data.colors = vueMethods.addLabel(data.colors);
    }
    state.homeData = data;
  },
  // اضاضه کردن یک کالبک فانکشن با واقعه لود شدن خانه
  // این تابع بعد لود شدن خانه اجرا میشه
  addHomeRetrievedEvent(state, callback) {
    if (state.homeData) {
      callback(state.homeData);
    } else {
      state.onHomeDataRetrieved.push(callback);
    }
  },
};
const actions = {
  async getIndexPageContent({ commit, state }, key) {
    // من ریدم توی ای پی آی ها که هیچکدوم یک شکل نیستن اینجوری بچه هم میتونه با دیتابیس کار کنه
    let apiKey = {
      "vip-unpublished-products": "vip_unpublished_products",
      suggestions: "suggestions",
      "most-discounts": "mostDiscount",
      "most-sales": "mostSales",
      "new-products": "new_products",
      "discount-product": "discount_products",
      "free_shipping_products":"free_shipping_products"

    };
    let finded = state.oldRequestedProduct.find((request) => {
      if (request.key == key) {
        return request;
      }
    });
    if (finded) {
      return finded.value;
    } else {
      let res = await axios.get(`front/${key}`);
      commit("changeOldRequestList", {
        key: key,
        value: res.data.data.response[apiKey[key]],
      });
      return res.data.data.response[apiKey[key]];
    }
  },

  async getSlidersFromServer({ commit }) {
    // https://api.atlasmode.ir/v1/front/sliders
    let response = await axios.get("/front/sliders");
    commit("setSliders", response.data.data.response);
    console.log(response);
  },
  async callGiftPackages({ commit, state }) {
    const { data } = await axios.get("/front/gift_packages");
    commit("setGiftPackages", data.data.gift_packages);
  },
  async getHomeDataFromServer({ commit, state }, payLoad) {
    //گرفتن اطلاعات مورد نیاز در صفحه اصلی
    let $root = payLoad.$root;
    // در صورت لاگین بودن کاربر کوکی ست میشود و اطلاعات کاربری نیز دریافت میشود
    if (vueMethods.getCookie("Authorization")) {
      axios.defaults.headers.common["Authorization"] = vueMethods.getCookie(
        "Authorization"
      );
    }
    commit("setHomeDataStatus", true);
    await axios
      .get("/front/home")
      .then((response) => {
        const data = response.data.data.response;
        commit("setHomeData", data);
        commit("setFalties",data.falties)
        commit("setHomeDataStatus", false);
        $root.onPushTokenReceived((newPushToken) => {
          if (data.user.user && newPushToken != data.user.device_token) {
            axios.post("customer/device-token", {
              device_token: newPushToken,
            });
          }
        });
        // اجرا کردن توابعی که منتظر لود شدن خانه هستن
        state.onHomeDataRetrieved.forEach((func) => {
          func(data);
        });
      })
      .catch((error) => {
        console.error(error);
      });
  },
};
export default {
  state,
  getters,
  mutations,
  actions,
};
